<template>
  <div class="create-plan">
    <seasonSelector />
    <div class="div-edit-plan">
      <!-- <label class="col-12 col-md-4 mb-3"> Nombre del plan
        <n-input placeholder="Nombre del plan" v-model:value="currentPlanData.name"></n-input>
      </label> -->
      <newMultislider v-if="this.currentPlanData.totalSize" :products="this.getProducts" />
      <SeedTable class="mt-2" v-for="(division, i) in this.currentPlanData.divisions" :key="i" :divisionNumber="i + 1"
        :loading="this.loading" :seedTable="division.seeds" :selectedProduct="division.product?.name"
        :selectedProductColor="division.product?.color" :selectedProductIcon="division.product?.icon"
        :currentDivision="i + 1" :divisionSize="division.sizeInHectares" />
    </div>
    <AuthModal v-if="showAuthModal" @clickOutsideOfModal="this.showAuthModal = false" :storePlan="storePlan" />
    <ConfirmModal v-if="showConfirmModal" @cancel="handleCancel" @confirm="handleConfirm"
    text="Has modificado tu plan ¿quieres guardar los cambios?" />
    <div class="btn-container">
      <button class="btn confirm-btn" @click="goToMyPlans">Ir a mis planes</button>
      <button class="btn confirm-btn" @click="handleStorePlan">Guardar plan</button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "pinia";
import authStore from "../../store/auth";
import planStore from "../../store/plan";
import productStore from "../../store/product";
import seedStore from "../../store/seed";
import Multislider from "../../components/multislider.vue";
import SeedTable from "../../components/SeedTable.vue";
import seasonSelector from "../../components/seasonSelector.vue";
import TotalSizeModal from "../../components/totalSizeModal.vue";
import userProducts from "../../components/userProducts.vue";
import newMultislider from "../../components/newMultislider.vue";
import AuthModal from "../../components/authModal.vue";
import ConfirmModal from '../../components/confirmModal.vue';

export default {
  data() {
    return {
      products: [],
      showAuthModal: false,
      storePlan: true,
      planCopy: {},
      isPlanSaved: false,
      showConfirmModal: false
    };
  },
  components: {
    seasonSelector,
    TotalSizeModal,
    userProducts,
    Multislider,
    newMultislider,
    SeedTable,
    AuthModal,
    ConfirmModal
  },
  async beforeUnmount() {
    await this.updateCurrentPlanData(null, 'returnToDefault')
  },
  beforeRouteLeave(to, from) {
    const isThePlanModified = ! _.isEqual(this.currentPlanData, this.planCopy);
    if(isThePlanModified && !this.isPlanSaved) {
      this.showConfirmModal =  true;
      return new Promise((resolve) => {
          this.resolvePromise = resolve
      })
    }
  },
  async mounted() {
    await this.updateCurrentPlanData(await this.getById(this.$route.params.id), 'getById')
    this.products = await this.getAllProducts();
    await this.getAllSeeds();
    this.planCopy = _.cloneDeep(this.currentPlanData);
  },
  computed: {
    ...mapState(planStore, ["currentPlanData", "getDivisions", "loading"]),
    getProducts() {
      if (!this.currentPlanData.season) {
        return this.products;
      } else {
        return this.products.filter((product) => product?.season[this.currentPlanData.season] === true);
      }
    },
    ...mapState(authStore, ["isLoggedIn"]),
    ...mapState(seedStore, ["allSeeds"]),
  },
  methods: {
    ...mapActions(seedStore, ["getAllSeeds"]),
    ...mapActions(productStore, [
      'getAllProducts'
    ]),
    ...mapActions(planStore, [
      "getById",
      'updateCurrentPlanData',
      "updatePlan",
    ]),
    goToMyPlans() {
      this.$router.push({ name: "plan-list" })
    },
    async handleStorePlan() {
      try {
        await this.updatePlan(this.$route.params.id)
        this.goToMyPlans();
        this.isPlanSaved = true;
      } catch (e) { throw e }
    },
    async handleConfirm() {
        await this.handleStorePlan();
        this.resolvePromise(true);
        this.showConfirmModal = false;
    },
    handleCancel() {
        this.resolvePromise(true);
        this.showConfirmModal = false;
    },
  },
};
</script> 

<style scope>
.btn-container {
  position: fixed;
  bottom: 0rem;
  background-color: #f4f4f4;
  border-top: 1px solid lightgrey;
  width: 100%;
  height: 5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  z-index: 100;
  box-shadow: 0 0.0625rem 0.375rem 0 rgba(0, 0, 0, 0.1);
}

.btn {
  width: 42%;
  height: 2.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-btn {
  font-size: 0.95rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
}

.confirm-btn:hover {
  background-color: #cec600;
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}

.create-plan {
  display: flex;
  justify-content: center;
}

.div-edit-plan {
  margin-top: 9rem; 
  margin-bottom: 10rem;
}

@media screen and (max-width: 700px) {

  .confirm-btn {
    /* width: 80% !important; */
    padding: 1.375rem 1.125rem 1.375rem 1.125rem;
  }

  .div-edit-plan {
    margin-top: 6rem; 
    margin-bottom: 5rem;
  }




}
</style>
